

export default function Footer() {
    return (
        <footer className="p-4 footer footer-center text-base-content mt-44">
            <aside>
                <p>Copyright © {new Date().getFullYear()} - All right reserved by <a className="underline transition duration-200 text-primary hover:text-green-700 " href="https://innovue.mpxin.com" target="_blank"  rel="noopener noreferrer">Innovue</a></p>
            </aside>
        </footer>
    )
}